/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

const urlParts = hostname => {
  const parts = hostname?.split?.('.');

  if (parts?.length !== 4) {
    throw new Error(`Invalid hostname: ${hostname}`);
  }

  return {
    service: parts[0],
    region: parts[1],
    secondLevelDomain: parts[2],
    topLevelDomain: parts[3],
  };
};

export const getWsHostname = hostname => {
  if (!hostname) {
    throw new Error('Missing hostname');
  }

  if (hostname === 'localhost' || hostname.startsWith('localhost.')) {
    return 'ws.develop.commandalkon.io';
  }

  const { service, region } = urlParts(hostname);
  let wsHostname = `ws.${region}.commandalkon.io`;

  if (service.endsWith('-ice') || service.endsWith('-cool')) {
    const lastHyphenIndex = service.lastIndexOf('-');
    const environment = service.slice(lastHyphenIndex + 1);
    wsHostname = `${environment}.${wsHostname}`;
  }

  return wsHostname;
};

export const getWsUrl = (hostname, wsPath = '') => {
  const wsHostname = getWsHostname(hostname);

  return `wss://${wsHostname}${wsPath}`;
};
